import { render, staticRenderFns } from "./DeleteTransactionDetail.vue?vue&type=template&id=6676dfda&scoped=true"
import script from "./DeleteTransactionDetail.vue?vue&type=script&lang=js"
export * from "./DeleteTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./DeleteTransactionDetail.vue?vue&type=style&index=0&id=6676dfda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6676dfda",
  null
  
)

export default component.exports